"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parameter = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
exports.Parameter = function (props) {
    var name = props.name, description = props.description, detailContent = props.detailContent, iconClassName = props.iconClassName, onAdd = props.onAdd, intl = props.intl;
    var _a = tslib_1.__read(react_1.useState(false), 2), displayHelp = _a[0], setDisplayHelp = _a[1];
    var theme = sdk_ui_theme_provider_1.useTheme();
    var isDark = theme && sdk_ui_theme_provider_1.isDarkTheme(theme);
    var id = "" + util_1.stringUtils.simplifyText(name) + (description ? util_1.stringUtils.simplifyText("_" + description) : "");
    var itemClassNames = classnames_1.default("gd-list-item gd-menu-item", "s-parameter-" + id, iconClassName);
    var addButtonLabel = intl.formatMessage({
        id: "configurationPanel.drillIntoUrl.editor.addParameterButtonLabel",
    });
    return (react_1.default.createElement("div", { id: id, className: itemClassNames, onClick: function () { return onAdd(); } },
        react_1.default.createElement("span", { className: "gd-parameter-title" }, name),
        description ? react_1.default.createElement("span", { className: "addon s-parameter-description" },
            "(",
            description,
            ")") : null,
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button gd-button-link s-parameter-add-button", value: addButtonLabel }),
        react_1.default.createElement("div", { className: "gd-list-item-tooltip" },
            react_1.default.createElement("span", { className: "gd-icon-circle-question gd-list-item-tooltip-icon s-parameter-help-icon", onMouseEnter: function () { return setDisplayHelp(true); }, onMouseLeave: function () { return setDisplayHelp(false); } }),
            displayHelp ? (react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "themed-bubble " + (isDark ? "bubble-primary" : "bubble-light"), alignTo: "#" + id, alignPoints: [{ align: "cr tl" }] }, detailContent)) : null)));
};
//# sourceMappingURL=Parameter.js.map